export default __webpack_public_path__ + "static/media/028-lawyer.7cf84893.svg";